import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Logger from './Logger';

/**
 * Custom hook to automatically sync Logger with Redux state
 * This ensures the Logger always has the latest authentication tokens
 * Mirrors the iOS app's approach of keeping auth state in sync
 */
export const useLoggerSync = () => {
    const tokens = useSelector((state) => state.userInfo?.tokens);
    
    useEffect(() => {
        if (tokens) {
            Logger.shared.updateAuthTokens(tokens);
        }
    }, [tokens]);
    
    return Logger.shared;
};

export default useLoggerSync;
